import type { Glyph } from "./types";

export const BellIcon: Glyph = (props) => (
  <svg
    viewBox="0 0 50 50"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M25 5.5V9.5" />
    <path d="M25 9.5C18.6 9.5 13.8 14.6 13.8 21V25.5C13.8 30.5 12 34 9 37.5H41C38 34 36.2 30.5 36.2 25.5V21C36.2 14.6 31.4 9.5 25 9.5Z" />
    <path d="M20.5 41C21.2 43.3 22.9 44.5 25 44.5C27.1 44.5 28.8 43.3 29.5 41" />
  </svg>
);

export default BellIcon;
